import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { FeaturesSection } from './components/FeaturesSection';
import { ProcessSection } from './components/ProcessSection';
import { PricingSection } from './components/PricingSection';
import { InteriorAISection } from './components/InteriorAISection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-apple-black font-sans selection:bg-apple-blue selection:text-white relative overflow-hidden" data-id="element-0">
      {/* Decorative background orbs */}
      <div className="gradient-orb w-[600px] h-[600px] bg-blue-300 top-[200px] -right-[200px] fixed" data-id="element-1" />
      <div className="gradient-orb w-[500px] h-[500px] bg-purple-300 top-[800px] -left-[200px] fixed" data-id="element-2" />
      <div className="gradient-orb w-[400px] h-[400px] bg-emerald-200 top-[2000px] right-[100px] fixed" data-id="element-3" />

      <Navigation data-id="element-4" />
      <main className="relative z-10" data-id="element-5">
        <HeroSection data-id="element-6" />
        <TrustBar data-id="element-7" />
        <div className="section-gradient-4" data-id="element-8">
          <InteriorAISection data-id="element-9" />
        </div>
        <div className="section-gradient-1" data-id="element-10">
          <FeaturesSection data-id="element-11" />
        </div>
        <div className="section-gradient-4" data-id="element-12">
          <ProcessSection data-id="element-13" />
        </div>
        <div className="section-gradient-2" data-id="element-14">
          <PricingSection data-id="element-15" />
        </div>
        <div className="section-gradient-5" data-id="element-16">
          <TestimonialsSection data-id="element-17" />
        </div>
        <div className="section-gradient-3" data-id="element-18">
          <FAQSection data-id="element-19" />
        </div>
      </main>
      <Footer data-id="element-20" />
    </div>;
}